/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Help interface.
 */
export function instanceOfHelp(value) {
    let isInstance = true;
    isInstance = isInstance && "progress" in value;
    return isInstance;
}
export function HelpFromJSON(json) {
    return HelpFromJSONTyped(json, false);
}
export function HelpFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        progress: json.progress,
    };
}
export function HelpToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        progress: value.progress,
    };
}
